import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	severity: string | null;
	name: string | null;
	isActive: boolean | null;
	fromDate: number | null;
	toDate: number | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: false,
	sortFieldName: 'alarmId',
	severity: null,
	name: null,
	isActive: null,
	fromDate: null,
	toDate: null,
};

const alarmHistoryFlexidas = createSlice({
	name: 'alarmHistoryFlexidas',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setSeverity: (state, action: PayloadAction<{ severity: string | null }>) => {
			state.severity = action.payload.severity;
			state.page = initialState.page;
		},
		setName: (state, action: PayloadAction<{ name: string | null }>) => {
			state.name = action.payload.name;
			state.page = initialState.page;
		},
		setIsActive: (state, action: PayloadAction<{ isActive: boolean | null }>) => {
			state.isActive = action.payload.isActive;
			state.page = initialState.page;
		},
		setFromDate: (
			state,
			action: PayloadAction<{ fromDate: number | null }>,
		) => {
			if (action.payload.fromDate) {
				state.fromDate = startOfDayInMilliseconds(action.payload.fromDate);
			} else {
				state.fromDate = null;
			}

			state.page = initialState.page;
		},
		setToDate: (
			state,
			action: PayloadAction<{ toDate: number | null }>,
		) => {
			if (action.payload.toDate) {
				state.toDate = startOfDayInMilliseconds(action.payload.toDate);
			} else {
				state.toDate = null;
			}

			state.page = initialState.page;
		},
		resetAlarmHistoryTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setSeverity,
	setName,
	setIsActive,
	setFromDate,
	setToDate,
} = alarmHistoryFlexidas.actions;

export default alarmHistoryFlexidas.reducer;
